/* eslint-disable @typescript-eslint/no-unused-vars */
import type { AppState } from "@appsmith/reducers";
import type { Module } from "@appsmith/constants/ModuleConstants";

export const getAllModules = (
  state: AppState,
): Record<string, Module> | any => {};

export const getCurrentModuleId = (state: AppState) => "";
